import CircularProgress from "./CircularProgress";

interface LoadingComponentProps {
  isLoading: boolean;
  variant?: 'spin'|'box';
  title?: string;
  children: React.ReactNode;
}

export const LoadingComponent = ({ isLoading, children, variant='spin',title}:LoadingComponentProps) => {
  return (
    <div className="relative">
      {children}
      {isLoading && variant==='spin' && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <CircularProgress size={48}/>
        </div>
      )}
      {isLoading && variant==='box' && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className=" bg-white rounded-md  p-12">
              {title}
          </div>
        </div>
      )}
    </div>
  );
};

